var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"app-title",class:[_vm.size && `app-title-size--${_vm.size}`, _vm.weight && `app-title-weight--${_vm.weight}`, _vm.classes]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }